/* global Blockly */
import React from 'react';
import { userIcon } from './index';

function defineBlock(context) {
    return {
        init: function () {
            this.appendDummyInput('WIDGET')
                .appendField('get')
                .appendField(new Blockly.FieldImage(userIcon, 30, 30, "user icon", null), 'userIcon')
                .appendField(new Blockly.FieldVariable(),'VARIABLE')
                .appendField('field');

            this.appendDummyInput().appendField(new Blockly.FieldDropdown([
                ["id", "UserId"],
                ["first name", "FirstName"],
                ["last name", "LastName"],
                ["full name", "FullName"],
                ["email", "Email"],
                ["system id", "UserSysId"]
            ]), "FIELDTYPE");

            this.appendStatementInput('CALLBACK');

            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Get the selected field type of a logged in user.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#user");
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let variableName = Blockly.JavaScript.variableDB_.getName(block.getField('VARIABLE').getText(), Blockly.Variables.NAME_TYPE);
            let callback = Blockly.JavaScript.statementToCode(block, 'CALLBACK');
            let fieldType = this.getFieldValue('FIELDTYPE');
            return 'Snap.user.get' + fieldType + '(function(' + variableName + ') {' + callback + '});\n';
        }
    }
}

const GetUserField = function (props) {
    const name = 'snap_user_get_field';
    GetUserField.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}></block>;
}

export default GetUserField;
